import HighlightedText from '@components/primitives/Text/HighlightedText'
import { classMerge } from '@components/utilities/classMerge'
import type { TextColor } from '@lib/colors/colors'
import type { RefinementListItem as RefinementListItemType } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList'
import type { MouseEvent } from 'react'

const DEFAULT_ITEM_CLASSNAMES =
  'px-2 py-0 flex flex-row items-center justify-between hover:cursor-pointer first:rounded-t-lg last:rounded-b-lg'

export const RefinementListItem = ({
  highlightColor,
  item,
  selectedItemHandler,
}: {
  highlightColor?: TextColor
  item: RefinementListItemType
  selectedItemHandler: (
    itemValue: string,
  ) => (event: MouseEvent<HTMLLIElement>) => void
}) => {
  return (
    <li
      className={classMerge(DEFAULT_ITEM_CLASSNAMES, {
        'bg-neutral50 hover:bg-success50': item.isRefined,
        'bg-white hover:bg-success50': !item.isRefined,
      })}
      key={item.label}
      onClick={selectedItemHandler(item.value)}
    >
      <div className={'m-0 p-2'}>
        <HighlightedText
          attribute='label'
          color={highlightColor}
          hit={item}
          styleName='p-strong'
        />
      </div>
    </li>
  )
}
